import { useNavigate } from "react-router";
import { BsCart3 } from "react-icons/bs";
import atoms from "../../../atoms";
import { StorePopup } from "../../../../Context";
import { useContext, useState } from "react";
import { CiUser } from "react-icons/ci";
import { Tooltip } from "react-tooltip";
import { MdStorefront } from "react-icons/md";
import { TbLogout } from "react-icons/tb";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { RightSectionProps } from "../interface";
import "../Header.scss"
import GoogleTranslate from "../../../../googleTranslate";
import { isStoreKuwaitRegion } from "../../../../constants/utils";
import useSessionStorage from "../../../../hooks/useSessionStorage";

const { Badge } = atoms;

export const RightSection = ({
    storeList,
    logout,
    activeTab,
    notificationCount
}: RightSectionProps) => {
    const navigate = useNavigate();
    const authDetail: any = localStorage?.getItem("auth_details");
    const [toggleDropdown, setToggleDropdown] = useState(false);
    const [storeDetails] = useSessionStorage<any>('store_details', {});
    const { setIsShow } = useContext<any>(StorePopup);
    const Auth_details = localStorage?.getItem("auth_details")
        ? JSON.parse(authDetail)
        : {};
    return (
        <>
            {
                <div className="nav-item my-auto mx-md-3 position-relative">
                    <div
                        className={`nav-link p-0 style-class position-relative cursor-pointer ${activeTab == "salesCart" &&
                            !(location?.pathname?.split("/")[1] == "pending")
                            ? "active"
                            : ""
                            }`}
                        onClick={() => navigate("/sales-cart")}
                        style={{
                            border: "1px solid #a9a9a9",
                            borderRadius: "50%",
                        }}
                    >
                        <div className="sales-cart-icon">
                            <BsCart3 />
                        </div>
                    </div>
                    <Badge
                        count={notificationCount?.sales_cart_count}
                        className={`translate-sales-cart ${notificationCount?.sales_cart_count < 10 && "padding-sales-cart"
                            }`}
                    />
                </div>
            }

            <div className="d-block">
                <div className="d-flex align-items-center ">
                    <div className="d-none d-md-block text-end color-black fs-14 fw-500">
                        <div className="m-auto">{Auth_details?.username}</div>
                        {(storeDetails?.store_name || localStorage.getItem("store_name")) ? (
                            <div
                                style={{
                                    maxWidth: "300px", // increase width as needed
                                    whiteSpace: "normal", // allow wrapping
                                    wordBreak: "break-word", // break long words if necessary
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3, // limit to 2 lines
                                    WebkitBoxOrient: "vertical"
                                }}
                            >
                                {storeDetails?.store_location || localStorage.getItem("store_location") ? `${storeDetails?.store_location || localStorage.getItem("store_location")}` : ""}
                            </div>
                        ) : (
                            ""
                        )}

                    </div>
                    <Dropdown
                        group
                        isOpen={toggleDropdown}
                        size="lg"
                        toggle={() => setToggleDropdown(!toggleDropdown)}
                    >
                        <DropdownToggle className="dropdown-button-hide cursor-pointer p-2">
                            {/* <Image src={User} /> */}
                            <div
                                className={`nav-link p-0 style-class position-relative cursor-pointer`}
                                style={{
                                    border: "1px solid #a9a9a9",
                                    borderRadius: "50%",
                                }}
                            >
                                <div className="nav-user-icon">
                                    <CiUser />
                                </div>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu>
                            {storeList.length > 1 && (
                                <div
                                    className="p-0 d-flex header-dropdown align-items-center cursor-pointer gap-1 ps-3"
                                    onClick={() => setIsShow(true)}
                                >
                                    <MdStorefront />
                                    <span className=" p-2">Select Store</span>
                                </div>
                            )}
                            <div
                                className="p-0 d-flex header-dropdown align-items-center cursor-pointer gap-1 ps-3"
                                onClick={() => logout()}
                            >
                                <TbLogout />
                                <span className=" p-2">Logout</span>
                            </div>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
                {isStoreKuwaitRegion() && <GoogleTranslate />}
            </div>
        </>
    );
};
